<script>
export default {};
</script>

<template>
  <div>
    Clusters
  </div>
</template>
